<template>
  <div>
    <Map />
  </div>
</template>

<script setup lang="ts">
import { provide, ref, onMounted } from 'vue'
import Map from './components/Map.vue'
const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})
provide('config', props.data)

const token = ref('' as string)

provide('token', token)

onMounted(async() => {
  token.value = await generateToken();
})
async function generateToken() {
  try {
    const response = await fetch('/api/ArcGisToken');
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.access_token;
  } catch (error) {
    console.error('Error:', error);
  }

}
</script>
